module.exports = __webpack_public_path__ + "img/star-ai-bg@2x.4ee3534a.png";